import React, { useEffect, useState } from 'react';
import { Box, Checkbox, TableCell, TableRow, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Autocomplete, Chip, CircularProgress, Typography } from '@mui/material';
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../../constants';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { editApprovalStatusApi, getConsantApi } from '../apiServices';
import { checkApiStatus, getGlobalCookie } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { ActionPerformed } from '../../../../shared_elements/components';
import LessMoreComp from '../../../../shared_elements/components/CustomLessMoreComp';
import { PageLoader } from '../../../../shared_elements';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import NumericLabel from 'react-pretty-numbers';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from '../../../../shared_elements/components/popover';

const ObligationsList = ({uploadedFileData, slug, uploadFileProgressData, viewFileStatus, toggleBulkOps, viewFile, viewRevisonHistory,item, onView, onEdit, onDelete, bulk, params, getResponseBack }) => {

    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(item);
    const [error, setError] = useState({});
    const [pltConstants, setPltConstants] = useState([]);
    const [statusModal, setStatusModal] = useState({ modal: false, data: null })
    const [dropDownLoader,setDropDownLoader]=useState(false)

    useEffect(() => {
        getPltConstants()
    }, [])
    useEffect(() => {
        if (item?.id) {
            setData(item);
        }
    }, [item]);

    useEffect(() => {
        if (statusModal.modal && item?.id) {
            setData(item);
            setError({});
        }
    }, [statusModal.modal, item]);

    const getPltConstants = () => {
        setDropDownLoader(true)
        globalPostService(getConsantApi(), { 'constant_types': ['obligation_approval_status'] })
            .then(response => {
                setDropDownLoader(false)
                if (checkApiStatus(response)) {
                    setLoading(false)
                    setPltConstants(response?.data?.data)
                }
            })
    }

    const onFieldChange = (key, value) => {
        if (key === "status") {
            setData(prev => ({ ...prev, status: value, reason: "" }));
            setError(prev => ({ ...prev, status: "", reason: "" }));
            return;
        }
        setData(prev => ({ ...prev, [key]: value }));
        setError(prev => ({ ...prev, [key]: "" }));
    }

    const userinfo = JSON.parse(getGlobalCookie('lessorAccess'))

    const onApprovalStatus = (obligationSlug) => {

        let validationInputs = {};
            data?.status && data.status.value === 2 ? validationInputs = {
                ...validationInputs,
                status: data?.status ? "" : 'Please select Status',
                reason: data?.reason ? "" : 'Please Enter Valid Reason'
            } : validationInputs = {
                status: data?.status ? "" : 'Please select Status',
            }

        let payload = Object.assign({}, data)

        payload = {
            status: payload?.status ? payload?.status?.value : null,
            reason: payload?.reason ? payload?.reason : null
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            globalPutService(editApprovalStatusApi(params, obligationSlug), payload)
                .then(async (response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        setStatusModal({ modal: false, data: null })
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Obligation Status`, success_msg: response?.data?.message, item_id: data?.id, payload: payload, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Obligation Status`, error_msg: response?.data?.message, item_id: data?.id, payload: payload, response: response?.data })
                    }
                });
        } else {
            setError(validationInputs)
            trackActivity(`Item Edited`, { page_title: `Edit Obligation Status`, error_msg: validationInputs, })

        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Obligations Listing`, page_type: page_type, })
    }
    return (
        <>
            <TableRow>
                <TableCell className="table-actions-list">
                    <Box className="table-icon-container">
                        <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'party', operationType: ['D'] }}>
                            <Checkbox style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={toggleBulkOps} />
                        </PermissionWrapper>
                        <AuditPopover item={item}>
                            <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                        </AuditPopover>
                        <Tooltip title="Revision History">
                            <RestoreIcon className='revision-history' fontSize="small" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} color="primary" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['R'] }}>
                            <Tooltip title="View">
                                <VisibilityIcon fontSize="small" onClick={() => { onView(); handleItemClicked('ViewIcon') }} color="primary" sx={{ cursor: "pointer" }} />
                            </Tooltip>
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['U'] }}>
                        {item?.status?.value!==1?
                            <Tooltip title="Edit">
                                    <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
                            </Tooltip>
                         : null}
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['D'] }}>
                            <Tooltip title="Delete">
                                <DeleteIcon fontSize="small" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} color="error" sx={{ cursor: "pointer" }} />
                            </Tooltip>
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['R'] }}>
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                        <AttachFileIcon fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count"> ({item.attachments.length}) </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                        </PermissionWrapper>
                      { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                    </Box>
                </TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width:  '150px' }}>{item?.obligation_type?.label || '--'}</div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: '150px' }}>{item?.sub_type?.label || '--'}</div></TableCell>
                {/* <TableCell>{item?.currency?.name || '--'}</TableCell> */}
                <TableCell sx={{ minWidth: "140px", cursor: 'pointer' }} onClick={() => {onView(); handleItemClicked();}}> {data?.sub_type?.value === 1 ? ( <NumericLabel params={{ locales: 'en-GB', currency: true, precision: 2, currencyIndicator: item?.currency?.code, commafy: true, justification: "L", }}>{Number(item.value)}</NumericLabel> ) : ( "--" )} </TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.details?.length > 50 ? "250px" : ''}}><LessMoreComp name={item?.details} lessMr='details' /></div></TableCell>
                <TableCell><div style={{ width: '130px' }}>
                    <Chip size='small'
                        className={`status-${item?.status?.value}`}
                        sx={{
                            width: "100px",
                            ...(userinfo?.user?.id === item?.to_be_approved_by?.id && item?.status?.value === 0
                                ? {
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease-in-out',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                    },
                                }
                                : {}),
                        }}
                        label={<span style={{ display: 'flex', alignItems: 'center', gap: 4, }}> {item?.status?.label}
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['U'] }}>
                                {userinfo?.user?.id === item?.to_be_approved_by?.id && item?.status?.value === 0 ?
                                    <Tooltip title='Change Obligation Status'>
                                        <ArrowDropDownIcon onClick={() => { setStatusModal({ modal: true, data: item }); handleItemClicked('Change Obligation StatusIcon') }} />
                                    </Tooltip>
                                    : null}
                            </PermissionWrapper>
                        </span>} />
                </div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: '130px' }}>{item?.applicable?.label || '--'}</div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: '150px' }}>{item?.to_be_approved_by?.name || '--'}</div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.payment_due_date ? moment(item?.payment_due_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: '150px' }}>{item?.frequency?.label || '--'}</div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{width: item?.copies?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.copies} lessMr='Copies' /></div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{width: item?.guarantor?.length > 50 ? "200px" : ''}}><LessMoreComp name={item?.guarantor} lessMr='Guarantor' /></div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: '100px' }}>{item?.required === 1 ? 'Yes' : item?.required === 2 ? 'No' : '--'}</div></TableCell>
                <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{width: item?.remarks?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.remarks} lessMr='remarks' /></div></TableCell>
            </TableRow>

            {statusModal.modal && (
                <Dialog aria-labelledby="customized-dialog-title"
                    key={statusModal?.data?.id}
                    className='add-lease-dialog'
                    open={true} >
                    <DialogTitle sx={{ m: 0, p: 2, }} id="customized-dialog-title">
                        <Typography sx={{marginLeft: "10px"}}>{"Change Status"}</Typography>
                    </DialogTitle>
                    <DialogContent dividers style={{ width: "400px" }}>
                        <Grid container spacing={2}>
                            <Grid item size={{ md: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    options={pltConstants?.filter(item => item?.type === 'obligation_approval_status')?.filter(opt => opt?.value !== item?.status?.value)}
                                   noOptionsText={dropDownLoader ? "loading" :"No Option Available" }
                                    value={data?.status || null}
                                    onChange={(e, value) => onFieldChange("status", value)}
                                    renderInput={(params) => 
                                    <TextField {...params} label="Status" margin='normal' size='small' 
                                    slotProps={{ inputLabel: { shrink: true } , input:{ ...params?.InputProps,endAdornment: (<>{dropDownLoader ? ( <CircularProgress color="inherit" size={20} />) : null} {params?.InputProps?.endAdornment} </> ) }} }
                                     required
                                        error={error?.status}
                                        helperText={error?.status || ''}
                                        
                                    />}
                                />
                            </Grid>
                            <Grid item size={{ md: 12 }}>
                                <TextField
                                    id="status_change_reason"
                                    label="Reason"
                                    variant="outlined"
                                    size='small'
                                    value={data?.reason || ''}
                                    onChange={(e) => onFieldChange('reason', e.target.value)}
                                    required={data?.status?.value === 2}
                                    margin='normal'
                                    fullWidth
                                    multiline
                                    rows={3}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    error={error?.reason}
                                    helperText={error?.reason || ''}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className="dialog-action">
                        <Button size="small" className='cancel-btn' disableRipple
                            onClick={() => { setStatusModal({ modal: false, data: null }); trackActivity('Item Clicked', { page_title: `Change Obligation Status`, page_type: 'Cancel Button' })}}color="primary" variant="outlined" >
                            Cancel
                        </Button>
                        <Button size="small"
                            onClick={() => { trackActivity('Item Clicked', { page_title: `Change Obligation Status`, page_type: 'Save Button' }); onApprovalStatus(item?.slug) }}
                            color="primary" variant="contained"
                            disabled={data?.status && data?.status?.value === 0}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default ObligationsList;